import React, { useEffect, useState } from 'react';
import styles from '../styles/survey.module.css';
import { SurveyServices } from '../services/SurveyServices';
import { useLocation } from "react-router-dom";


const FirstQuestion = ({ onQuestionPress, surveyData }) => {
  const location = useLocation();
  const [paymentConfirm, setPaymentConfirm] = useState(false);

  const questionPress = (id) => {
    onQuestionPress(id);
  }

  useEffect(() => {

    let paymentConfirmation = location.state.afterPaymentSurveyFlag;
    setPaymentConfirm(paymentConfirmation);

  }, [location.state]);

  // useEffect(() => {
  //   const onSurveyInit = () => {
  //     window.dataLayer.push({
  //       event: 'startSurvey',
  //       eventProps: {
  //         label: "Start Survey",
  //       }
  //     });
  //   }
  //   onSurveyInit();
  // }, [surveyData])


  const closePaymentConfirmationPoup = () => {
    setPaymentConfirm(false);
  }

  return (
    <div>
      <h2 className={styles.header}>What brings you to<br />Device Tracker Plus?</h2>
      <div className={styles.questionContainer}>
        {surveyData.map(({ id, title, description, logo }) => (
          <div key={id} className={styles.surveyQuestion} onClick={() => questionPress(id)}>
            <img src={SurveyServices.GetSurveyIconUrl(logo)} alt="surveyIcon" className={styles.surveyIcon} />
            <div className={styles.questionTextContent}>
              <p className={styles.questionTitle}>{title}</p>
              <p className={styles.questionDescription}>{description}</p>
            </div>
          </div>
        ))}
      </div>

      {paymentConfirm &&
        <div className={styles.paymentConfirmationPoup}>
          <h4 className={styles.paymentConfirmationTitle}>Thank you</h4>
          <p className={styles.paymentConfirmationParagraph}>We received your paiment.</p>
          <div className={styles.dissmissButtonContainer}>
            <button className={styles.cancelButton} onClick={closePaymentConfirmationPoup}>Close</button>
          </div>
        </div>
      }
    </div>
  )
}

export default FirstQuestion